import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Clipboard from "@saleor/components/Clipboard";
import FormSpacer from "@saleor/components/FormSpacer";
import React from "react";

export interface DeepLinkProps {
  linkId: string;
  linkUrl: string;
  shortLinkUrl: string;
  onGenerateDeeplink: (id: string) => void;
  disabled?: boolean;
}

const DeepLink: React.FC<DeepLinkProps> = ({
  linkId,
  linkUrl,
  shortLinkUrl,
  onGenerateDeeplink,
  disabled
}) => (
  <Card>
    <CardTitle title="Deeplink Details" />
    <CardContent>
      <Clipboard
        label="Collection Id"
        value={linkId}
        onGenerate={() => undefined}
        disabled={disabled}
      />
      <FormSpacer />
      <Clipboard
        label="Deeplink URL"
        value={linkUrl}
        onGenerate={() => onGenerateDeeplink(linkId)}
        disabled={disabled}
      />
      <FormSpacer />
      <Clipboard
        label="Short Dynamic URL"
        value={shortLinkUrl}
        onGenerate={() => onGenerateDeeplink(linkId)}
        disabled={disabled}
      />
    </CardContent>
  </Card>
);
export default DeepLink;
